// extracted by mini-css-extract-plugin
export default {"MainModal":"MainModal_MainModal__qZ1ln","drawer":"MainModal_drawer__uV91e"};